export { default } from './FloppyDisk'
